import { action, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsStepIndicator } from '__generated__/api';
import StepIndicator = FlightsStepIndicator.Fragment;

export class StepIndicatorStore extends Store {
  @observable public stepIndicator: StepIndicator;
  @observable public multiItemPriceToken: string;
  @observable public showStepIndicator: boolean;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setJourneyContinuationIdInStepIndicator = (journeyContinuationId?: string) => {
    this.stepIndicator
      ? (this.stepIndicator.journeyContinuationId = journeyContinuationId)
      : (this.stepIndicator = {
          __typename: 'FlightsStepIndicator',
          journeyContinuationId: journeyContinuationId,
          errorAnalytics: null
        });
  };

  @action
  public setMultiItemPriceToken = (multiItemPriceToken?: string) => {
    this.multiItemPriceToken = multiItemPriceToken;
  };

  @action
  public setStepIndicatorVisibility = (showStepIndicator?: boolean) => {
    this.showStepIndicator = showStepIndicator;
  };
}

StepIndicatorStore.DEFAULTS = {
  stepIndicator: {
    journeyContinuationId: null,
    errorAnalytics: null
  },
  showStepIndicator: true
};
